module.exports = __webpack_public_path__ + "media/audio2.6ddec31c.mp3";